import styled from 'styled-components';
import { GlobalToken } from 'antd';

const YearlyViewContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  position: relative;

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .ant-tabs-nav {
      margin: 0;

      .ant-tabs-nav-wrap {
        display: flex;
        justify-content: center;
        margin-left: ${({ theme: { token } }) => token.marginXXS}px;

        .ant-tabs-tab {
          padding: 0 ${({ theme: { token } }) => token.paddingSM}px;
          margin: 0 ${({ theme: { token } }) => token.marginXS}px ${({ theme: { token } }) => token.marginXXS}px
            ${({ theme: { token } }) => token.marginXS}px;
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          background-color: ${({ theme: { token } }) => token.colorPrimary};
          height: 3px;
          border-radius: 5px 5px 0 0;
        }
      }
    }
  }

  h1 {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  }

  .footer {
    display: flex;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    align-items: center;
  }

  .asterisk {
    color: ${({ theme: { token } }) => token.colorError};
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .efficiency-card {
    width: 100%;
    height: 100%;
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    border: 2px solid ${({ theme: { token } }) => token.colorPrimary};
  }

  .system-health-card {
    width: 100%;
    height: 100%;
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    border: 2px solid ${({ theme: { token } }) => token.colorPrimary};
  }
  .graph-label-parentheses {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }
`;

export default YearlyViewContainer;
